var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 64,
    viewBox: "0 0 54 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9193 53.3796L26.6237 54.0894L27.328 53.3796L42.2245 38.3669C50.4355 30.0919 50.4355 16.6755 42.2245 8.40046C34.0135 0.125444 20.7008 0.125448 12.4898 8.40046L12.1231 8.77007C3.70954 17.2492 3.70955 30.9966 12.1231 39.4758L25.9193 53.3796Z",
    fill: "#1CB5E7",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3858 3.22168C21.5882 3.45495 16.858 5.41783 13.1941 9.11032L12.8273 9.47993C4.80276 17.567 4.80277 30.6788 12.8273 38.7659L26.3858 52.4302V3.22168Z",
    fill: "#56CCF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2A467B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0304 14.3999C27.9755 15.3131 29.0272 16.2876 29.9367 17.2314L28.8697 18.6089V18.6803L31.6946 19.9456L33.605 18.6293L32.4568 17.3437V17.2518C33.6406 16.41 34.6568 15.5988 35.8 14.8285L35.2461 20.5884H18.7538L18.2 14.8285C19.3431 15.5988 20.3593 16.41 21.5431 17.2518V17.3437L20.3898 18.6293L22.3002 19.9456L25.1251 18.6803V18.6089L24.0632 17.2314C24.9727 16.2876 26.0244 15.3131 26.9695 14.3999H27.0304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1192 21.6293L34.9668 23.5527H28.8698V30.1851H31.8421C32.5077 30.1851 33.2037 29.481 33.0615 29.0218C32.9482 28.7065 32.7741 28.4167 32.5492 28.1689C32.3242 27.9212 32.0529 27.7204 31.7506 27.578C31.8624 27.578 33.8998 26.0475 34.855 25.42C34.8144 25.8332 34.1284 31.2564 34.1234 31.3432L27.0559 34.0114H26.9441L19.897 31.3228C19.8919 31.236 19.2162 25.8128 19.1654 25.3995C20.1206 26.0475 22.158 27.5576 22.2647 27.5576C21.9624 27.7 21.6911 27.9008 21.4662 28.1485C21.2412 28.3963 21.0671 28.6861 20.9538 29.0014C20.8116 29.4606 21.5077 30.1647 22.1732 30.1647H25.1455V23.5323H19.0485L18.8809 21.6089L35.1192 21.6293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 54,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipPin);
export default __webpack_public_path__ + "static/media/ship-pin.a9fede58fcb39677d64db8b3a6252815.svg";
export { ForwardRef as ReactComponent };